/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { Component, Inject, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { faEyeIcon } from 'IconLibrary/fontawesome/regular/eye';
import { faTimesIcon } from 'IconLibrary/fontawesome/regular/times';
import { fasTrashAltIcon } from 'IconLibrary/fontawesome/solid/trash-alt';
import { SvgIconRegistry } from '@ngneat/svg-icon';
import { TranslocoService } from '@jsverse/transloco';
import { DialogRef } from '../../../aero/aero-dialog/types';
// eslint-disable-next-line import/no-cycle
import { DeleteAccountDialogService } from './delete-account-dialog.service';

/**
 * Component that loads when clicked on delete account button.
 */
@Component({
  selector: 'delete-account-dialog',
  templateUrl: './delete-account-dialog.component.html',
  styleUrls: ['./delete-account-dialog.component.scss'],
  standalone: false,
})
export class DeleteAccountDialogComponent implements OnInit {

  /**
   * Specifies whether Account has password stored in db.
   */
  public hasPasswordStored: boolean;

  /**
   * Holds value of username or password based on the account type.
   */
  public usernameOrPassword: string = '';

  /**
   * Type of password field, toggle on clicking of eye icon.
   */
  public type: string = 'password';

  /**
   * Stores error message.
   */
  public errorMessage: string = null;

  /**
   * Stores error object.
   */
  public error: any = null;

  /**
   * Username of the logged-in user.
   */
  public username: string;

  /**
   * Account id of the logged-in user.
   */
  public accountId: string;

  public primaryDisabled = true;

  /**
   * Injecting required services.
   * @param dialogRef
   * @param config
   * @param translocoService
   * @param deleteAccountDialogService
   * @param svgIconRegistry
   */
  constructor(
    @Inject('DialogRef') private dialogRef:DialogRef,
    public config: DynamicDialogConfig,
    private translocoService: TranslocoService,
    private deleteAccountDialogService: DeleteAccountDialogService,
    private svgIconRegistry: SvgIconRegistry,
  ) {
    this.svgIconRegistry.register([
      faEyeIcon,
      faTimesIcon,
      fasTrashAltIcon,
    ]);
  }

  /**
   * Initializes the class properties with config values
   */
  ngOnInit(): void {
    if (this.config.data.error) {
      this.error = this.config.data.error.error;
      this.errorMessage = this.config.data.error.errorMessage;
    }
    this.hasPasswordStored = this.config.data.hasPasswordStored;
    this.username = this.config.data.username;
    this.accountId = this.config.data.accountId;
    this.dialogRef.setPrimaryDisabled(this.primaryDisabled);
    this.showError();
  }

  onValueChange(event) {
    this.dialogRef.setPrimaryDisabled(!this.usernameOrPassword);
    this.config.data.valueChange(this.usernameOrPassword);
  }

  /**
   * This method will handle password visibility on click of eye icon.
   */
  toggleFieldType() {
    this.type = this.type === 'password' ? 'text' : 'password';
  }

  showError() {
    this.deleteAccountDialogService.serviceSubject.subscribe((data: any) => {
      if (data.error) {
        this.errorMessage = data.error;
        this.error = this.usernameOrPassword;
      }
      if (data.close) {
        this.dialogRef.getDynamicDialogRef().destroy();
      }
    });
  }
}
